import { Typography, Card } from "@mui/material";
import { LinkButton } from "@/components";

function Page404() {
  return (
    <Card className="flex flex-col items-center gap-4 px-16 py-8">
      <Typography component="h1" variant="h1" align="center">
        404
      </Typography>

      <div>
        <Typography component="h2" variant="h5" align="center">
          Page not found.
        </Typography>
        <Typography variant="body1" align="center">
          The page you are looking for might have been removed.
        </Typography>
      </div>

      <LinkButton to="/">
        Return to website
      </LinkButton>
    </Card>
  );
}

export default Page404;
